// The dialog the shell mounts registers here, and a mutation's `mutationFn` asks through it: module state
// and not a context, because the asker is called from outside React.

type Asker = () => Promise<boolean>

let asker: Asker | null = null

export function registerPasswordAsker(next: Asker | null): void {
  asker = next
}

/** `true` once the password was given and accepted; `false` if the person gave up, or nothing can ask. */
export function askForPassword(): Promise<boolean> {
  return asker === null ? Promise.resolve(false) : asker()
}
